import React, { useState } from "react";
import { Box, TextField } from "@material-ui/core";
import { formatCellValue } from "../utils/formatters";

export const EditableCellComponent = ({
  value,
  config,
  currencySymbol,
  onChange,
  onBlur,
  isTotalRow = false,
  fontWeight,
}) => {
  // Use dataAlign if specified, otherwise fall back to align
  const dataAlignment = config.dataAlign !== undefined ? config.dataAlign : (config.align || "right");
  const [localValue, setLocalValue] = useState(
    value != null && value !== "-" ? String(value) : ""
  );

  const handleChange = (event) => {
    const inputValue = event.target.value;
    setLocalValue(inputValue);

    // Allow empty input for editing
    if (inputValue === "") {
      return;
    }

    const numValue = parseFloat(inputValue);
    if (!isNaN(numValue)) {
      // Round to whole number for percentage types
      const roundedValue = config.type === "percentage" ? Math.round(numValue) : numValue;
      
      // Validate min/max if provided
      if (config.min !== undefined && roundedValue < config.min) {
        return;
      }
      if (config.max !== undefined && roundedValue > config.max) {
        return;
      }
      onChange(roundedValue);
    }
  };

  const handleBlur = () => {
    // Validate on blur
    const numValue = parseFloat(localValue);
    if (isNaN(numValue) || localValue === "") {
      setLocalValue(value != null && value !== "-" ? String(value) : "");
    } else {
      // Round to whole number for percentage types
      const roundedValue = config.type === "percentage" ? Math.round(numValue) : numValue;
      
      if (config.validate && !config.validate(roundedValue)) {
        setLocalValue(value != null && value !== "-" ? String(value) : "");
      } else {
        // Update with rounded value if it's different
        if (roundedValue !== numValue) {
          onChange(roundedValue);
        }
      }
      if (onBlur) {
        onBlur();
      }
    }
  };

  React.useEffect(() => {
    setLocalValue(value != null && value !== "-" ? String(value) : "");
  }, [value]);

  const [isFocused, setIsFocused] = useState(false);
  
  // Format the display value when not focused
  const displayValue = !isFocused && value != null && value !== "-"
    ? formatCellValue(value, config.type, currencySymbol)
    : "";

  return (
    <Box
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: dataAlignment === "left" ? "flex-start" : dataAlignment === "center" ? "center" : "flex-end",
        padding: "4px 8px",
        cursor: "text",
      }}
      onClick={() => !isFocused && setIsFocused(true)}
    >
      {!isFocused ? (
        <Box
          component="span"
          style={{
            textAlign: dataAlignment,
            width: "100%",
            fontWeight: fontWeight || (isTotalRow ? "bold" : "normal"),
            overflow: "visible",
            wordWrap: "break-word",
            whiteSpace: "normal",
            display: "block",
          }}
        >
          {displayValue || "-"}
        </Box>
      ) : (
        <TextField
          value={localValue}
          onChange={handleChange}
          onBlur={() => {
            setIsFocused(false);
            handleBlur();
          }}
          autoFocus
          size="small"
          variant="outlined"
          inputProps={{
            style: {
              textAlign: dataAlignment,
              padding: "4px 8px",
            },
            min: config.min,
            max: config.max,
            step: config.type === "percentage" ? 1 : undefined,
          }}
          placeholder={config.type === "percentage" ? "Enter value..." : ""}
          style={{
            width: "100%",
          }}
        />
      )}
    </Box>
  );
};

